import { makeStyles } from "@material-ui/core/styles";
import ClassNames from "classnames";
import styles from "./index.module.scss";

import Rating from "@material-ui/lab/Rating";

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: "2.5rem",
    "& .MuiRating-label": {
      marginBottom: 0,
    },
    "& .MuiRating-iconFilled": {
      color: theme.palette.primary.active,
    },
    "& .MuiRating-iconHover": {
      color: theme.palette.primary.hover,
    },
  },
}));

export default function StarRatingCard({
  value,
  setValue,
  readOnly,
  ...props
}) {
  const classes = useStyles();

  return (
    <div className={styles.starRatingCard}>
      {readOnly ? (
        <div
          className={ClassNames(styles.starRatingCardWrapper, styles.readOnly)}
        >
          <div className={styles.starRating}>
            <Rating
              className={classes.root}
              name="star-rating"
              value={value}
              readOnly
            />
          </div>
        </div>
      ) : (
        <div className={ClassNames(styles.starRatingCardWrapper, styles.input)}>
          <div className={styles.label}>{props.label}</div>
          <div className={styles.starRating}>
            <Rating
              className={classes.root}
              name="star-rating"
              value={value}
              onChange={(event, newValue) => {
                if (localStorage.sessionCheckPointData) {
                  const temp = JSON.parse(localStorage.sessionCheckPointData);
                  temp.rating = newValue;
                  localStorage.setItem(
                    "sessionCheckPointData",
                    JSON.stringify(temp)
                  );
                }
                setValue(newValue);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}